(function () {
  'use strict';
  var d = document;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  var upsellData = null;
  function getUpsellData() {
    if (upsellData !== null) return upsellData;
    var s = $('[data-kp-upsells]');
    try { upsellData = s ? JSON.parse(s.textContent) : {}; } catch (e) { upsellData = {}; }
    return upsellData;
  }
  function renderUpsell(cart) {
    var el = $('[data-kp-upsell]'); if (!el) return;
    var data = getUpsellData();
    if (!cart.items.length) { el.hidden = true; el.innerHTML = ''; return; }
    // If the offer needs BOTH products and they have exactly one, the other one
    // is the single most useful thing we can show — it is what turns the tee
    // free. Only nudge when they already hold one; otherwise it is just an ad.
    var pair = data.pair || [];
    if (GIFT && GIFT.mode === 'all_of' && pair.length > 1) {
      var missing = pair.filter(function (p) {
        return !cart.items.some(function (it) {
          return it.product_id === p.product_id && !isGiftLine(it);
        });
      });
      if (missing.length === 1) {
        var need = missing[0];
        var vs = need.variants || [];
        el.hidden = false;
        // Ask for a SIZE rather than adding a default variant. Apparel added
        // blind at "first available" is a return waiting to happen.
        var picker = vs.length
          ? '<button type="button" class="kp-upsell__btn" data-kp-upsell-pick aria-expanded="false">add +</button>'
          : '<button type="button" class="kp-upsell__btn" data-qa-add data-variant-id="' + need.id + '">add +</button>';
        var panel = vs.length
          ? '<div class="kp-upsell__pick" data-kp-upsell-panel hidden>' +
              '<span class="kp-upsell__pickhint">select a size</span>' +
              '<div class="kp-upsell__sizes">' +
                vs.map(function (v) {
                  return '<button type="button" data-qa-add data-variant-id="' + v.id + '"' +
                    (v.available ? '' : ' disabled aria-label="' + esc(v.title) + ' sold out"') +
                    '>' + esc(String(v.title).toLowerCase()) + '</button>';
                }).join('') +
              '</div></div>'
          : '';
        el.innerHTML = '<div class="kp-upsell__label">unlock your free tee</div>' +
          '<div class="kp-upsell__card">' +
            '<img src="' + esc(need.img) + '" alt="">' +
            '<div class="kp-upsell__info"><div class="kp-upsell__nm">' + esc(need.title) + '</div>' +
              '<div class="kp-upsell__sub">add it — your free ' + esc(data.giftLabel || '$70') + ' tee drops in</div></div>' +
            picker +
          '</div>' + panel;
        return;
      }
    }
    var hasTrack = cart.items.some(function (it) {
      var h = ((it.handle || '') + ' ' + (it.product_type || '') + ' ' + (it.product_title || '')).toLowerCase();
      return h.indexOf('tracksuit') > -1;
    });
    // never sell the add-on when it is the gift the reconciler gives away free
    var addonIsGift = !!(GIFT && data.addon && data.addon.product_id === GIFT.product_id);
    if (hasTrack && data.addon && !addonIsGift) {
      el.hidden = false;
      el.innerHTML = '<div class="kp-upsell__label">finish the fit</div>' +
        '<div class="kp-upsell__card">' +
          '<img src="' + esc(data.addon.img) + '" alt="">' +
          '<div class="kp-upsell__info"><div class="kp-upsell__nm">' + esc(data.addon.title) + '</div><div class="kp-upsell__sub">' + esc(data.addon.price) + '</div></div>' +
          '<button type="button" class="kp-upsell__btn" data-qa-add data-variant-id="' + data.addon.id + '">add +</button>' +
        '</div>';
    } else { el.hidden = true; el.innerHTML = ''; }
  }

  /* ------------------------------------------------------------------ *
   * free-gift offer — auto-add                                         *
   *                                                                    *
   * Mirrors whichever Shopify automatic discount is configured. Shopify *
   * owns the money; this owns only what goes in the bag. Current offer: *
   * "buy any K1 tracksuit, get a free beanie" (any_of mode, 1/order).   *
   *                                                                    *
   * Shape is a RECONCILER, not an add-hook: after every cart mutation   *
   * we compute the gift quantity the cart should have and converge on   *
   * it. That makes the item-removed, quantity-changed, /cart-page       *
   * form-post and returning-session paths all fall out of one code      *
   * path instead of needing a hook each.                               *
   * ------------------------------------------------------------------ */
  var GIFT = (function () {
    var el = $('[data-kp-gift-config]');
    if (!el) return null;
    try { var c = JSON.parse(el.textContent); return c && c.enabled ? c : null; }
    catch (e) { return null; }
  })();

  var giftBusy = false;
  var giftReloaded = false;

  // set when the discount did NOT zero an auto-added tee (promo ended, product
  // fell out of the collection, ...). Stops an add -> remove -> add loop and,
  // more importantly, stops us billing a shopper for a "free" gift. Persisted
  // for the session so we don't re-test it on every single page load.
  function giftUnavailable() {
    try { return sessionStorage.getItem('kp_gift_unavailable') === '1'; } catch (e) { return false; }
  }
  function markGiftUnavailable() {
    try { sessionStorage.setItem('kp_gift_unavailable', '1'); } catch (e) {}
  }

  // the shopper removing the gift themselves is a decision — remember it for
  // the session, otherwise the tee reappears on every cart touch and the site
  // reads as broken.
  function giftDeclined() {
    try { return sessionStorage.getItem('kp_gift_declined') === '1'; } catch (e) { return false; }
  }
  function declineGift() {
    try { sessionStorage.setItem('kp_gift_declined', '1'); } catch (e) {}
  }

  function isGiftLine(it) {
    return !!(GIFT && it.properties && it.properties[GIFT.flag]);
  }
  function isQualifying(it) {
    return !!GIFT && GIFT.qualifying_ids.indexOf(it.product_id) > -1;
  }

  // Promos differ in SHAPE, not just in which products they list:
  //   any_of — one item from the list earns the gift (the old tracksuit offer)
  //   all_of — EVERY listed product must be in the bag (buy both colourways)
  // A config with no mode behaves exactly as before, so an older/reverted
  // gift-offer snippet keeps working unchanged.
  function cartQualifies(cart) {
    if (!GIFT || !GIFT.qualifying_ids || !GIFT.qualifying_ids.length) return false;
    if (GIFT.mode === 'all_of') {
      return GIFT.qualifying_ids.every(function (id) {
        return cart.items.some(function (it) {
          return it.product_id === id && it.quantity > 0 && !isGiftLine(it);
        });
      });
    }
    return sumQty(cart.items.filter(isQualifying)) > 0;
  }
  function sumQty(items) {
    return items.reduce(function (n, it) { return n + it.quantity; }, 0);
  }
  function giftLines(cart) { return cart.items.filter(isGiftLine); }

  // a tee the shopper chose and paid for already earns the discount on its own,
  // so don't stack a second one on top of it — their tee just goes to $0.
  function ownedGiftProductQty(cart) {
    return sumQty(cart.items.filter(function (it) {
      return it.product_id === GIFT.product_id && !isGiftLine(it);
    }));
  }

  function sizeOf(it) {
    return it.variant_title ? String(it.variant_title).split(' / ')[0].trim() : null;
  }
  // size the gift to the qualifying item they actually bought. In all_of mode
  // both required products are present by definition, so pick by CONFIG order
  // (the first listed product wins) — otherwise the tee size would depend on
  // which colourway happened to be added first. any_of is left untouched.
  function giftSizeFor(cart) {
    if (GIFT && GIFT.mode === 'all_of') {
      for (var i = 0; i < GIFT.qualifying_ids.length; i++) {
        var id = GIFT.qualifying_ids[i];
        var hit = cart.items.filter(function (it) { return it.product_id === id && !isGiftLine(it); })[0];
        if (hit) return sizeOf(hit);
      }
    }
    var t = cart.items.filter(isQualifying)[0];
    return t ? sizeOf(t) : null;
  }
  // Every size they'd accept. With two tracksuits in different sizes, any of
  // them is a valid gift size — comparing only against the first would make the
  // gift flap (remove/re-add) every time the line order shifted.
  function acceptableGiftSizes(cart) {
    return cart.items.filter(isQualifying).map(sizeOf).filter(Boolean);
  }
  function giftVariantFor(size) {
    if (size && GIFT.variants[size]) return GIFT.variants[size];
    if (size && GIFT.variants[size.toUpperCase()]) return GIFT.variants[size.toUpperCase()];
    return GIFT.fallback_variant_id;
  }

  function desiredGiftQty(cart) {
    if (!GIFT || giftUnavailable() || giftDeclined()) return 0;
    if (!cartQualifies(cart)) return 0;
    // the discount grants ONE free tee per order regardless of tracksuit count
    // (verified against the live cart), so never add more than it will zero.
    return Math.max(0, (GIFT.max || 1) - ownedGiftProductQty(cart));
  }

  function postChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  function postAddGift(variantId, qty) {
    // value is cosmetic — isGiftLine() only tests the KEY for truthiness — but it
    // shows on the order line, so keep it accurate to the promo that earned it.
    var props = {}; props[GIFT.flag] = GIFT.flag_value || 'gift';
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty, properties: props }] })
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  // Safety net. We never trust that the tee came out free — we check. A tee that
  // qualifies for nothing still carries a separate 50%-off-tees discount, so a
  // mistaken gift bills $35 rather than failing loudly. Any gift line we'd be
  // charged for comes straight back out, every time we look.
  function dropBilledGiftLines(cart) {
    var billed = giftLines(cart).filter(function (l) { return l.final_line_price > 0; });
    if (!billed.length) return Promise.resolve(cart);
    var chain = Promise.resolve(cart);
    billed.forEach(function (l) {
      chain = chain.then(function () { return postChange(l.key, 0); });
    });
    return chain.then(getCart);
  }

  // Only called on the tail of an add WE made into a cart that qualifies. If the
  // tee still isn't free there, the discount genuinely isn't doing its job, so
  // stop retrying for this session (otherwise every cart touch would add-then-
  // remove forever).
  //
  // This is deliberately NOT used when merely observing an existing cart: a gift
  // line sitting at 50% because the shopper just removed their tracksuit is a
  // normal transient state, and latching on it disabled the offer for the whole
  // session — the "remove then re-add and the tee never returns" bug.
  function verifyGiftWeJustAdded(cart) {
    var billed = giftLines(cart).filter(function (l) { return l.final_line_price > 0; });
    if (!billed.length) return Promise.resolve(cart);
    markGiftUnavailable();
    return dropBilledGiftLines(cart);
  }

  function clearGiftLines(cart) {
    var chain = Promise.resolve(cart);
    giftLines(cart).forEach(function (l) {
      chain = chain.then(function () { return postChange(l.key, 0); });
    });
    return chain;
  }

  function syncGift(cart) {
    if (!GIFT || giftBusy) return Promise.resolve(cart);

    var lines = giftLines(cart);
    // A gift in the bag has to be free EVERY time we look at it, not just in the
    // moment we added it. The promo can lapse while a cart sits there overnight,
    // and then the shopper is quietly being charged $35 for a "free" tee.
    var billed = lines.filter(function (l) { return l.final_line_price > 0; });

    var want = desiredGiftQty(cart);
    var have = sumQty(lines);
    var wantSize = giftSizeFor(cart);
    // they switched tracksuit size after the tee landed — resize the tee too
    var okSizes = acceptableGiftSizes(cart);
    // a one-size gift (the beanie) has no size to drift: its line reports a
    // null size, which would otherwise read as a mismatch and clear/re-add the
    // gift on every single cart touch
    var giftSized = Object.keys(GIFT.variants || {}).length > 1;
    var sizeDrift = giftSized && want > 0 && lines.length === 1 && okSizes.length > 0 &&
      okSizes.indexOf(sizeOf(lines[0])) === -1;

    if (!billed.length && want === have && !sizeDrift && lines.length < 2) {
      return Promise.resolve(cart);
    }

    giftBusy = true;
    var chain;

    if (billed.length) {
      // A gift we'd be charged for comes out first, whatever else is going on.
      // No latching here — the usual reason is simply that the tracksuit just
      // left the cart, and the shopper may well put it back.
      chain = dropBilledGiftLines(cart);
    } else {
      var needsRebuild = want === 0 || sizeDrift || lines.length > 1;
      chain = needsRebuild ? clearGiftLines(cart) : Promise.resolve(cart);
      var after = needsRebuild ? 0 : have;
      if (want > after) {
        chain = chain
          .then(function () { return postAddGift(giftVariantFor(wantSize), want - after); })
          .then(getCart)
          .then(verifyGiftWeJustAdded);   // only our own add can prove the promo dead
      } else {
        chain = chain.then(getCart).then(dropBilledGiftLines);
      }
    }

    return chain
      .then(function (c) {
        giftBusy = false;
        // The /cart page is server-rendered with no JS cart, so a reconcile
        // there has to repaint via a reload or the shopper sees a stale bag.
        // Gated on the cart actually having changed AND once per page load —
        // otherwise a persistently failing add would reload forever.
        var changed = c.item_count !== cart.item_count || c.total_price !== cart.total_price;
        if (changed && !giftReloaded && d.body.classList.contains('template-cart')) {
          giftReloaded = true;
          location.reload();
        }
        return c;
      })
      .catch(function () { giftBusy = false; return getCart(); });
  }

  var drawer = $('#kpDrawer'), overlay = $('[data-kp-overlay]');
  // The nav panel and the cart drawer share ONE .kp-overlay. If each toggled it
  // directly, closing either would tear the backdrop out from under the other.
  // Every open/close routes through syncOverlay, which derives the backdrop from
  // whether ANYTHING is open.
  function navEl() { return $('.kp-nav'); }
  function syncOverlay() {
    var navOpen = !!(navEl() && navEl().classList.contains('kp-nav--open'));
    var drOpen = !!(drawer && drawer.classList.contains('open'));
    if (overlay) overlay.classList.toggle('open', navOpen || drOpen);
  }
  function closeMenu() {
    var n = navEl(); if (n) n.classList.remove('kp-nav--open');
    var hdr = $('.kp-header'); if (hdr) hdr.classList.remove('kp-header--above');
    var burger = $('[data-kp-menu]'); if (burger) burger.setAttribute('aria-expanded', 'false');
    syncOverlay();
  }
  function toggleMenu() {
    var n = navEl(); if (!n) return;
    var opening = !n.classList.contains('kp-nav--open');
    // Never leave two sliding panels on screen at once.
    if (opening && drawer && drawer.classList.contains('open')) closeDrawer();
    n.classList.toggle('kp-nav--open', opening);
    // The header is a stacking context; without this the panel sits under the backdrop.
    var hdr = $('.kp-header'); if (hdr) hdr.classList.toggle('kp-header--above', opening);
    var burger = $('[data-kp-menu]'); if (burger) burger.setAttribute('aria-expanded', opening ? 'true' : 'false');
    syncOverlay();
  }
  // The backdrop appears instantly but the drawer takes .32s to slide in, so the
  // second tap of a fast double-tap on "add to bag" landed on the backdrop and
  // shut the drawer 7ms after it opened (measured 2026-10-25). Backdrop taps
  // inside that window are ignored.
  var drawerOpenedAt = 0;
  function openDrawer() { closeMenu(); if (drawer) { if (!drawer.classList.contains('open')) drawerOpenedAt = Date.now(); drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); } syncOverlay(); }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); } syncOverlay(); }

  var toastT;
  function toast(m) { var t = $('#kpToast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 2200); }
  window.kpToast = toast;

  var lastCart = null;

  function renderItems(cart) {
    lastCart = cart;
    var box = $('[data-kp-cart-items]'); if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<p class="kp-drawer__empty">your bag is empty</p>';
    } else {
      box.innerHTML = cart.items.map(function (it) {
        var opt = it.variant_title ? esc(it.variant_title.toLowerCase()) : '';
        var gift = isGiftLine(it);
        // no quantity stepper on the gift: only one tee comes free, so letting
        // them bump it to 2 would quietly bill $70 for the second one.
        var controls = gift
          ? '<button type="button" class="kp-li__drop" data-kp-gift-remove data-key="' + esc(it.key) + '">remove</button>'
          : '<div class="kp-li__qty">' +
              '<button type="button" data-kp-qty="-" data-key="' + esc(it.key) + '" aria-label="decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-kp-qty="+" data-key="' + esc(it.key) + '" aria-label="increase">+</button>' +
            '</div>';
        return '' +
          '<div class="kp-li' + (gift ? ' kp-li--gift' : '') + '" data-key="' + esc(it.key) + '">' +
            '<img src="' + (it.image ? esc(it.image) : '') + '" alt="' + esc(it.product_title) + '" width="64" height="80">' +
            '<div>' +
              '<div class="kp-li__name">' + esc((it.product_title || '').toLowerCase()) + '</div>' +
              '<div class="kp-li__opt">' + opt + (gift ? ' <span class="kp-li__gift">free gift</span>' : '') + '</div>' +
              controls +
            '</div>' +
            '<div class="kp-li__price' + (gift ? ' kp-li__free' : '') + '">' + (gift ? 'free' : fmt(it.final_line_price)) + '</div>' +
          '</div>';
      }).join('');
    }
    var sub = $('[data-kp-cart-subtotal]'); if (sub) sub.textContent = fmt(cart.total_price);
    $$('[data-kp-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    renderUpsell(cart);
  }

  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh(open) {
    return getCart().then(syncGift).then(function (c) { renderItems(c); if (open) openDrawer(); }).catch(function () {});
  }

  function changeQty(key, qty) {
    return postChange(key, qty).then(syncGift).then(renderItems).catch(function () {});
  }
  // The drawer opens on the tap itself. Waiting for add + cart fetch measured
  // 0.87s live (2026-10-25), and a tap with no feedback reads as broken and
  // invites a second tap. The bag dims (aria-busy) until the server answers, a
  // tap during that window is ignored (no double add), and the gift reconcile
  // runs AFTER the paint instead of in front of it.
  var adding = null;
  function setAddBusy(on) {
    if (drawer) drawer.setAttribute('aria-busy', on ? 'true' : 'false');
    $$('[data-kp-add]').forEach(function (b) { b.setAttribute('aria-busy', on ? 'true' : 'false'); });
  }
  function addVariant(id, qty) {
    if (adding) return adding;
    var wasOpen = !!(drawer && drawer.classList.contains('open'));
    openDrawer();
    setAddBusy(true);
    adding = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) {
        // 422 is Shopify refusing the quantity; anything else is not "sold out".
        // Nothing was added, so don't leave a drawer open that the tap opened.
        if (!r.ok) { toast(r.status === 422 ? 'sold out' : 'something went wrong'); if (!wasOpen) closeDrawer(); return; }
        return getCart().then(function (c) {
          renderItems(c);
          toast('added to bag');
          syncGift(c).then(function (c2) { if (c2 !== c) renderItems(c2); }).catch(function () {});
        });
      })
      .catch(function () { toast('something went wrong'); })
      .then(function () { setAddBusy(false); adding = null; });
    return adding;
  }
  window.kpAddVariant = addVariant;
  window.kpRefreshCart = refresh;
  window.kpOpenCart = function () { return refresh(true); };

  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-kp-cart-open]')) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-kp-overlay]')) { if (Date.now() - drawerOpenedAt < 450) return; closeDrawer(); closeMenu(); return; }
    if (e.target.closest('[data-kp-cart-close]')) { closeDrawer(); return; }
    if (e.target.closest('[data-kp-menu-close]')) { e.preventDefault(); closeMenu(); return; }

    var drop = e.target.closest('[data-kp-gift-remove]');
    if (drop) {
      declineGift();  // their call — don't put it back this session
      // On /cart the markup is a real link and the page is server-rendered, so
      // let it navigate — swallowing the click would leave the removed line on
      // screen until a manual refresh.
      if (d.body.classList.contains('template-cart')) return;
      e.preventDefault();
      changeQty(drop.getAttribute('data-key'), 0);
      return;
    }

    var qbtn = e.target.closest('[data-kp-qty]');
    if (qbtn) {
      var li = qbtn.closest('.kp-li'); var key = qbtn.getAttribute('data-key');
      // defensive: if a gift line ever renders a stepper, treat a decrement to
      // zero as the shopper declining rather than something to reconcile back.
      if (qbtn.getAttribute('data-kp-qty') === '-' && lastCart) {
        var gl = lastCart.items.filter(function (x) { return x.key === key && isGiftLine(x); })[0];
        if (gl && gl.quantity <= 1) declineGift();
      }
      var span = li.querySelector('.kp-li__qty span'); var q = parseInt(span.textContent, 10) || 1;
      q += qbtn.getAttribute('data-kp-qty') === '+' ? 1 : -1;
      changeQty(key, Math.max(0, q)); return;
    }

    var pick = e.target.closest('[data-kp-upsell-pick]');
    if (pick) {
      e.preventDefault();
      var pnl = $('[data-kp-upsell-panel]');
      if (pnl) {
        var open = pnl.hasAttribute('hidden');
        if (open) pnl.removeAttribute('hidden'); else pnl.setAttribute('hidden', '');
        pick.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var f = pnl.querySelector('button:not([disabled])'); if (f) f.focus(); }
      }
      return;
    }

    var tog = e.target.closest('[data-qa-toggle]');
    if (tog) { e.preventDefault(); var panel = tog.parentElement.querySelector('.kp-qa'); $$('.kp-qa.open').forEach(function (p) { if (p !== panel) p.classList.remove('open'); }); if (panel) panel.classList.toggle('open'); return; }
    var qa = e.target.closest('[data-qa-add]');
    if (qa) { e.preventDefault(); if (qa.disabled) return; addVariant(qa.getAttribute('data-variant-id'), 1); var pnl = qa.closest('.kp-qa'); if (pnl) pnl.classList.remove('open'); return; }
    if (!e.target.closest('.kp-card')) $$('.kp-qa.open').forEach(function (p) { p.classList.remove('open'); });

    var acc = e.target.closest('[data-kp-acc]');
    if (acc) {
      // Set max-height from scrollHeight so the panel animates to its real height at any
      // length. The stylesheet's .kp-acc.open cap is a no-JS fallback only — it was 320px
      // and clipped the patchy-zip overview, measured at 338px. 2026-09-11
      var accBox = acc.closest('.kp-acc');
      var accBody = accBox.querySelector('.kp-acc__body');
      var accOpening = !accBox.classList.contains('open');
      accBox.classList.toggle('open');
      if (accBody) accBody.style.maxHeight = accOpening ? accBody.scrollHeight + 'px' : '';
      return;
    }

    var menu = e.target.closest('[data-kp-menu]');
    if (menu) { e.preventDefault(); toggleMenu(); return; }
    // tapping a link inside the panel navigates; close so a bfcache Back does not
    // restore the page with the panel still open over the content
    if (e.target.closest('.kp-nav a')) { closeMenu(); return; }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); $$('.kp-modal.open').forEach(function (m) { m.classList.remove('open'); }); }
  });

  // A Back out of checkout restores the JS heap AND the DOM, so a panel left open
  // would come back open with no way to have dismissed it. Reset on restore.
  window.addEventListener('pageshow', function (e) { if (e.persisted) { closeMenu(); closeDrawer(); } });

  // hydrate counts on load
  refresh(false);
})();
